import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserProfileRoutingModule } from './user-profile-routing.module';
import { SearchUserComponent } from './search-user/search-user.component';
import { GoalsPanelComponent } from './search-user/goals-panel/goals-panel.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { FormsModule } from '@angular/forms';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { PostsModule } from 'projects/app-core/src/app/posts/posts.module';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

@NgModule({
  declarations: [SearchUserComponent, GoalsPanelComponent],
  imports: [
    CommonModule,
    UserProfileRoutingModule,
    NzInputModule,
    NzCardModule,
    NzGridModule,
    NzSpinModule,
    FormsModule,
    NzTagModule,
    NzCollapseModule,
    NzTableModule,
    NzDividerModule,
    NzPaginationModule,
    NzDrawerModule,
    NzButtonModule,
    PostsModule,
    NzDropDownModule,
    NzSelectModule,
    NzListModule,
    NzModalModule,
    NzDatePickerModule,
    NzDescriptionsModule,
    NzInputNumberModule,
    NzSwitchModule,
  ],
})
export class UserProfileModule {}
